/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { Channel as IChannel, StationPolicy } from 'client-code/channels-service';
import { DimensionScaler } from '../device/DimensionScaler';

export class Channel {
    /**
     * The network that this channel is affiliated with.
     */
    affiliate?: string;

    /**
     * Date and time (UTC) at which this channel will no longer be availabile.
     * Missing means availabile.
     */
    availabilityWindowEnd?: string;

    /**
     * Date and time (UTC) at which this channel will become availabile.
     * Missing means availabile.
     */
    availabilityWindowStart?: string;

    /**
     * Call sign for the channel.
     */
    callSign?: string;

    /**
     * The ID for this channel.
     */
    channelId?: string;

    /**
     * Channel name.
     */
    name?: string;

    /**
     * Channel network information
     */
    channelNetworkInfo?: object;

    /**
     * Channel number in major-minor format.
     */
    channelNumber?: string;

    /**
     * Date and time (UTC) at which this channel will no longer be entitled.
     * Missing means entitlement will never be ended.
     */
    entitlementWindowEnd?: string;

    /**
     * Date and time (UTC) at which this channel will become entitled.
     * Missing means entitlement already started.
     */
    entitlementWindowStart?: string;

    /**
     * True if the channel is blocked by the user. Otherwise, false.
     */
    isBlocked?: boolean;

    /**
     * True if the channel is one of the user's favorites. Otherwise, false.
     */
    isFavorite?: boolean;

    /**
     * True if the channel offers pay per view content. Otherwise, false.
     */
    isPayPerView?: boolean;

    /**
     * Unique identifier of the linear provider for the channel.
     */
    linearProviderPartnerId?: string;

    /**
     * The logo index for client to retrieve channel logo.
     */
    logoIndex?: number;

    /**
     * A unique ID for the partner's station (alphanumeric).
     */
    partnerStationId?: string;

    /**
     * the applicable policy names for this channel.
     */
    policyName?: string[];

    /**
     * When true, the channel will prevent EAS (Emergency Alert System) interruptions.
     * Missing means false.
     */
    preventEasInterruption?: boolean;

    /**
     * The channel signal source type.
     */
    sourceType?: string;

    /**
     * Unique identifier of the station that is airing the offer.
     */
    stationId?: string;

    /**
     * A URI that describes the tuning parameters.
     */
    tuningUri?: string[];

    /**
     * Unique identifier of the recording provider for the channel.
     */
    recordingProviderPartnerId?: string;

    /**
     * Video resoultion of the channel.
     */
    videoResolution?: string;

    /**
     * channel logo url
     */
    channelLogoUrl: string;

    /**
     * subscription status of channel
     */
    isSubscribed: boolean;

    /**
     * Array of Station Policy
     */
    policyInfo?: Array<StationPolicy | undefined>;

    constructor(channel: IChannel, channelLogoBaseUrl: string) {
        this.affiliate = channel.affiliate;
        this.availabilityWindowEnd = channel.availabilityWindowEnd;
        this.availabilityWindowStart = channel.availabilityWindowStart;
        this.callSign = channel.callSign;
        this.channelId = channel.channelId;
        this.channelNetworkInfo = channel.channelNetworkInfo;
        this.channelNumber = channel.channelNumber;
        this.entitlementWindowEnd = channel.entitlementWindowEnd;
        this.entitlementWindowStart = channel.entitlementWindowStart;
        this.isBlocked = channel.isBlocked;
        this.isFavorite = channel.isFavorite;
        this.isPayPerView = channel.isPayPerView;
        this.linearProviderPartnerId = channel.linearProviderPartnerId;
        this.logoIndex = channel.logoIndex;
        this.name = channel.name;
        this.partnerStationId = channel.partnerStationId;
        this.policyName = channel.policyName;
        this.preventEasInterruption = channel.preventEasInterruption;
        this.recordingProviderPartnerId = channel.recordingProviderPartnerId;
        this.sourceType = channel.sourceType;
        this.stationId = channel.stationId;
        this.tuningUri = channel.tuningUri;
        this.videoResolution = channel.videoResolution;
        this.channelLogoUrl = channel.logoIndex
            ? `${channelLogoBaseUrl}/logos/${DimensionScaler.getInstance().getScaledWidth(
                  168,
              )}x${DimensionScaler.getInstance().getScaledHeight(48)}/${
                  channel.logoIndex - 65536
              }.png`
            : ' ';
        this.isSubscribed = false;
    }
}
